import { LedgerEntry } from "@/models/ledger"
import { formatDateString } from "@/lib/utils"

/**
 * Generates the display description for a ledger entry.
 * This matches the logic in ledger-columns.tsx
 */
export function getDisplayDescription(
  entry: LedgerEntry,
  t: (key: string, params?: Record<string, any>) => string
): string {
  // Order entries: automatic description if description is empty
  if (entry.orderId && !entry.description) {
    return t('automatic.orderFee', { orderNo: entry.orderNumber })
  }

  // Billing run entries: automatic description if description is empty
  if (entry.billingRunItemId && !entry.description) {
    return t('automatic.membershipFee', {
      memberName: entry.memberName,
      periodStart: entry.periodStart ? formatDateString(entry.periodStart) : '',
      periodEnd: entry.periodEnd ? formatDateString(entry.periodEnd) : ''
    })
  }

  // Regular entries: use the description as-is
  return entry.description
}

/**
 * Filters ledger entries by search term, including dynamic descriptions.
 */
export function filterLedgerEntriesBySearch(
  entries: LedgerEntry[],
  searchTerm: string,
  t: (key: string, params?: Record<string, any>) => string
): LedgerEntry[] {
  if (!searchTerm.trim()) {
    return entries
  }

  const lowerSearchTerm = searchTerm.toLowerCase()

  return entries.filter(entry => {
    const displayDescription = getDisplayDescription(entry, t)
    return displayDescription.toLowerCase().includes(lowerSearchTerm)
  })
}